export const waterBills = {
  cheongju: {
    up: 580,
    down: 1140,
    waterUse: 170,
    diameter: 1000
  },
  sejong: {
    up: 580,
    down: 1140,
    waterUse: 170,
    diameter: 1000
  },
  seoul: {
    up: 580,
    down: 1140,
    waterUse: 170,
    diameter: 1000
  }
}

export const getThisMonthWaterBill = (region = "cheongju", usage = 0, isLeak = false) => {
  const bill = waterBills[region]

  if (!bill) {
    return 0
  }

  const usageBill = (bill.up + bill.down + bill.waterUse) * usage

  const diameterBill = isLeak ? 0 : bill.diameter

  return Math.floor(usageBill + diameterBill)
}
